<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>11. Digitalisierung als Herausforderung: "Deep Dive" 1</h2>
          <p></p>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ChallengeDD1",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text:
            "Wahrnehmung der 'Einhaltung von Gesetzgebungen' als Herausforderung nach Tätigkeitsbereich."
        },
        plotOptions: {
          series: {
            dataLabels: {
              useHTML: true,
              enabled: true,
              formatter: function() {
                return this.series.marker;
              }
            }
          }
        },
        xAxis: {
          categories: [
            "Wissens./Forschung",
            "Bevölkerungs-/Katastrophenschutz",
            "Sport",
            "Gemeinschaftliche Versorgungsaufgaben",
            "Kirchen/religiöse Vereinigungen",
            "Soziale Dienste",
            "Internationale Solidarität",
            "Bildung/Erziehung",
            "Gesundheitswesen",
            "Wirtschafts-/Berufsverbände",
            "Kultur/Medien",
            "Andere",
            "Umwelt-/Naturschutz",
            "Freizeit/Geselligkeit",
            "Bürger-/Verbraucherinteressen"
          ]
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          valueSuffix: "%"
        },
        colors: ["#546825"],
        series: [
          {
            showInLegend: false,
            name: "",
            data: [
              71.08,
              69.38,
              68.21,
              68.18,
              67.82,
              66.49,
              66.2,
              64.71,
              64.31,
              64.29,
              63.41,
              61.48,
              59.15,
              58.57,
              55.17
            ]
          }
        ],
        exporting: {
          enabled: true,
          fallbackToExportServer: false
        }
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
